import { createFileRoute } from '@tanstack/react-router'
import { SupportEndedScreen } from '@/features/support/support-ended-screen'

/** Public route: shown when a support session ends (ADR-0033). */
export const Route = createFileRoute('/support/ended')({ component: SupportEndedScreen })
